import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();
  /*
   * TCR-2423 — route "*" nằm NGOÀI Layout nên trang này vẽ trực tiếp trên nền
   * #root (--sidebar-bg #1a1a2e). Chữ của <Result> là màu tối của antd
   * (#141414 / #6b6b6b) nên trước đây gần như vô hình (~1.1:1). Bọc nội dung
   * trong một card nền trắng bo góc, canh giữa màn hình: chữ đạt lại >= 4.5:1
   * mà không phải đổi màu/không đổi nội dung chữ.
   */
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 640,
          background: '#ffffff',
          borderRadius: 12,
          boxShadow: '0 6px 24px rgba(0, 0, 0, 0.25)',
        }}
      >
        <Result
          status="404"
          title="Không tìm thấy"
          subTitle="Trang bạn truy cập không tồn tại"
          extra={<Button type="primary" onClick={() => navigate('/')}>Về trang chủ</Button>}
        />
      </div>
    </div>
  );
}
